import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import PasswordResetComponent from 'src/modules/password-reset/PasswordReset.component';
import { Action } from 'redux';
import { 
  passwordReset,
  passwordResetClearErrors,
  PasswordResetAction
} from 'src/actions/authentication/password-reset/PasswordReset.actions';
import * as Types from 'src/actions/authentication/password-reset/Types';
import { match } from 'react-router';
import ApiClient from 'src/services/api-client/ApiClient';

interface DispatchProps {
  passwordReset: (resetRequest: { [key: string]: string }) => Promise<Action>;
  passwordResetClearErrors: () => void;
}

interface State {
  password: string;
  passwordConfirmation: string;
  success: boolean;
  errorMessage: { [key: string]: string };
  resetToken: string;
  email: string;
}

interface Props extends DispatchProps {
  match: match<{resetToken: string}>;
}

class PasswordResetContainer extends React.Component<Props, State> {

  state = {
    password: '',
    passwordConfirmation: '',
    success: false,
    errorMessage: {},
    resetToken: '',
    email: '',
  };

  public componentWillMount(): void {
    this.props.passwordResetClearErrors();
    this.setState({resetToken: this.props.match.params.resetToken});
    ApiClient.passwordRecovery.get(this.props.match.params.resetToken).then((response) => {
      this.setState({email: response.data.email});
    });
  }

  public render(): React.ReactNode {
    return (
      <PasswordResetComponent
        handleChange={(key: string) => this.handleChange(key)}
        handleSubmit={() => this.handleSubmit()}
        errorMessage={this.state.errorMessage}
        success={this.state.success}
      />
    );
  }

  private handleChange(key: string): (value: string | boolean) => void {
    return (value: string | boolean) => {
      const newState = {};
      newState[key] = value;
      this.setState(newState);
    };
  }

  private handleSubmit(): void {
    if (this.state.password.length === 0 || this.state.passwordConfirmation.length === 0) {
      this.setState({ errorMessage: { err: 'Deves llenar ambos campos.' } });
      return;
    }

    if (this.state.password !== this.state.passwordConfirmation) {
      this.setState({ errorMessage: { err: 'Las contraseñas no coinciden.' } });
      return;
    }

    this.props.passwordReset({
      password: this.state.password,
      password_confirmation: this.state.passwordConfirmation,
      token: this.state.resetToken,
        email: this.state.email
      }).then((response: PasswordResetAction) => {
      if (response.type === Types.PASSWORD_RESET_SUCCESS) {
        this.setState({ success: true });
      } else if (response.type === Types.PASSWORD_RESET_FAILURE) {
        this.setState({ errorMessage: response.payload });
      }
    });
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => ({
  passwordReset: (resetRequest: { [key: string]: string }): Promise<Action> => (
    dispatch(passwordReset(resetRequest))
  ),
  passwordResetClearErrors: (): Action => (
    dispatch(passwordResetClearErrors())
  )
});

export default connect(null, mapDispatchToProps)(PasswordResetContainer);



// WEBPACK FOOTER //
// ./src/modules/password-reset/PasswordReset.container.tsx